import { api } from "@/lib/api";

export const inventoryApi = {
  meta: () => api.get("/inventory/meta").then((r) => r.data),
  stats: () => api.get("/inventory/stats").then((r) => r.data),
  inbox: () => api.get("/inventory/inbox").then((r) => r.data),
  receive: (batch_ids, location) => api.post("/inventory/receive", { batch_ids, location }).then((r) => r.data),
  items: (params) => api.get("/inventory/items", { params }).then((r) => r.data),
  item: (id) => api.get(`/inventory/items/${id}`).then((r) => r.data),
  ledger: (params) => api.get("/inventory/ledger", { params }).then((r) => r.data),
  reserve: (id, so_no, note) => api.post(`/inventory/items/${id}/reserve`, { so_no, note }).then((r) => r.data),
  release: (id) => api.post(`/inventory/items/${id}/release`).then((r) => r.data),
  pick: (id) => api.post(`/inventory/items/${id}/pick`).then((r) => r.data),
  dispatch: (id, ref) => api.post(`/inventory/items/${id}/dispatch`, { ref }).then((r) => r.data),
  adjust: (id, new_meters, reason) => api.post(`/inventory/items/${id}/adjust`, { new_meters, reason }).then((r) => r.data),
  move: (id, location) => api.post(`/inventory/items/${id}/move`, { location }).then((r) => r.data),
};

export const INV_STATUS_STYLE = {
  Receiving: "bg-slate-100 text-slate-700",
  Available: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Reserved: "bg-blue-50 text-blue-700 border border-blue-200",
  Picked: "bg-violet-50 text-violet-700 border border-violet-200",
  Dispatched: "bg-slate-200 text-slate-500",
  Returned: "bg-amber-50 text-amber-700",
  Adjusted: "bg-rose-50 text-rose-700",
};

export const GRADE_STYLE = {
  A: "bg-emerald-50 text-emerald-700",
  B: "bg-amber-50 text-amber-700",
  C: "bg-orange-50 text-orange-700",
};
